if (process.env.NODE_ENV == 'production') {
	var setting = require('./setting.prod.json')
} else {
	setting = require('./setting.dev.json')
}

export default setting
